import Point from '@arcgis/core/geometry/Point';
import PoleItem from '@/utils/pole-item';
import mapUtils from '@/utils/map-utils';
import {
  poleGraphic,
} from './draw-poles';

//
// 選択電柱ポップアップ
//
export default async function polePopupSelected({
  view,
  layers,
  template,
  selected,
}) {
  if (!view) return false;
  console.debug('Popup pole',
      `selected=${selected?.fullText()}`);

  // 選択電柱なしならポップアップ非表示
  if (!selected?.drawable()) {
    view.closePopup();
    return false;
  }

  // 描画レイヤーの電柱グラフィックを検索
  const graphic = layers.draw.graphics.find((graphic) => {
    const pole = graphic.attributes;
    return selected?.same(pole);
  });

  // レイヤーになければ電柱マスタを検索
  const masterView = layers.masterView;
  const master = graphic ?? await findMasterLayer(selected, masterView);

  // 電柱マスタにもなければグラフィック作成
  // (初期表示時に電柱マスタ検索が空振りする)
  const feature = master ?? poleGraphic(selected, template);

  // 電柱ポップアップ
  view.openPopup({
    location: feature.geometry,
    features: [ feature ],
  });

  // 電柱が表示範囲外ならビュー移動
  if (!view.extent.contains(feature.geometry)) {
    view.goTo(feature, mapUtils.GOTO_OPTIONS)
        .catch((err) => console.info('Map error:', err.message));
  }
  return true;
}

// 電柱マスタレイヤー検索
async function findMasterLayer(selected, masterView) {
  if (!masterView) return null;

  // 緯度経度でレイヤー検索
  const query = masterView.createQuery();
  query.geometry = new Point({
    latitude: selected.latitude,
    longitude: selected.longitude,
  });
  query.distance = 8;
  const result = await masterView.queryFeatures(query);

  // 結果判定
  for (const feature of result.features) {
    const pole = new PoleItem(feature.attributes);

    // 電柱一致判定
    if (selected.same(pole)) {
      return feature;
    }
  }
  return null;
}
